export default __webpack_public_path__ + "static/media/user-vip.ade52a7d.svg";